import React, {useEffect, useRef} from 'react'
import {useToggle} from '@startlibs/core'

export const useDropFileEvents = (setFile) =>  {

  const isDraggingOver = useToggle()

  useEffect(() => {
    const dropbox = document.body
    const bubblingCounter = {current:0}
    const isValidFileDrag = (e) => {
      const dt = e.dataTransfer
      return dt?.effectAllowed !== "none" && (
        (dt.files && dt.files.length) ||
        (dt.types.contains && dt.types.contains("Files")) ||  // Valid in Chrome/Firefox
        (dt.types.includes && dt.types.includes("Files"))               // Valid in IE
      )
    }

    const overCallback = (e) => {
      if (!isValidFileDrag(e)) {
        return;
      }
      // dt.effectAllowed crashes IE 11 & 10 when files have been dragged from
      // the filesystem
      var effect = e.dataTransfer.effectAllowed;
      if (effect === "move" || effect === "linkMove") {
        e.dataTransfer.dropEffect = "move"; // for FF (only move allowed)
      } else {
        e.dataTransfer.dropEffect = "copy"; // for Chrome
      }
      isDraggingOver.openWith(dropbox.contains(e.target))
      e.stopPropagation();
      e.preventDefault();
    }
    const enterCallback = (e) => {
      if (!isValidFileDrag(e)) {
        return;
      }
      bubblingCounter.current += 1
    }
    const closeCallback = (e) => {
      if (!isValidFileDrag(e)) {
        return;
      }
      bubblingCounter.current -= 1
      if (!bubblingCounter.current) {
        isDraggingOver.close()
      }
    }
    const dropCallback = (e) => {
      bubblingCounter.current = 0;
      isDraggingOver.close()
      if (!isValidFileDrag(e)) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      setFile(e)
    }

    dropbox.addEventListener("dragenter", enterCallback);
    dropbox.addEventListener("dragover", overCallback);
    dropbox.addEventListener("dragleave", closeCallback);
    dropbox.addEventListener("drop", dropCallback)
    return () => {
      dropbox.removeEventListener("dragenter", enterCallback);
      dropbox.removeEventListener("dragover", overCallback);
      dropbox.removeEventListener("dragleave", closeCallback);
      dropbox.removeEventListener("drop", dropCallback)
    }
  }, [])

  return isDraggingOver
}
